import { useFormContext, useWatch } from 'react-hook-form';
import { useEffect } from 'react';
import { CurrencyInputV2, DocumentNumberFieldV2, FormFieldV2, SearchFieldV2 } from '@/components/custom/erp';
import { accountSearchColumns, MA_CHUNG_TU, QUERY_KEYS } from '@/constants';
import { InfoTabFormFieldStates } from '../../../hooks';
import { AccountModel } from '@/types/schemas';
import { Label } from '@/components/ui/label';
import InfoDropdown from '../InfoDropdown';
import { FormMode } from '@/types/form';

interface BasicInfoProps {
  formMode: FormMode;
  formFieldStates: InfoTabFormFieldStates;
  initialData?: BanHangRecord;
}

export default function BasicInfo({ formMode, formFieldStates, initialData }: BasicInfoProps) {
  const isViewMode = formMode === 'view';
  const { taiKhoan, setTaiKhoan, setQuyenChungTu, soChungTu, setSoChungTu } = formFieldStates;
  const { setValue } = useFormContext();
  const ngay_ct = useWatch({ name: 'ngay_ct' });

  useEffect(() => {
    if (ngay_ct) {
      setValue('ngay_lct', ngay_ct);
    }
  }, [ngay_ct, setValue]);
  const InforTab = (
    <div className='grid grid-cols-[3fr_1fr] gap-8 p-4'>
      <div className='space-y-4'>
        <div className='flex items-center space-x-4'>
          <Label className='w-32 shrink-0'>Loại phiếu thu</Label>
          <FormFieldV2
            type='select'
            className='w-[200px]'
            name='ma_ngv'
            options={[
              { value: '1', label: '1. Theo hóa đơn' },
              { value: '2', label: '2. Theo khách hàng' }
            ]}
            disabled={isViewMode}
          />
        </div>

        <div className='flex items-center space-x-4'>
          <Label className='w-32 shrink-0'>Diễn giải</Label>
          <div className='flex-1'>
            <FormFieldV2 name='dien_giai' disabled={isViewMode} className='w-full' />
          </div>
        </div>

        <div className='flex items-center space-x-4'>
          <Label className='w-32 shrink-0'>Tài khoản nợ</Label>
          <div className='flex-1'>
            <SearchFieldV2<AccountModel>
              type='text'
              displayRelatedField='name'
              columnDisplay='code'
              searchEndpoint={`/${QUERY_KEYS.TAI_KHOAN}`}
              searchColumns={accountSearchColumns}
              dialogTitle='Danh mục tài khoản'
              disabled={isViewMode}
              value={taiKhoan?.code || ''}
              relatedFieldValue={taiKhoan?.name || ''}
              onRowSelection={setTaiKhoan}
            />
          </div>
        </div>
      </div>

      <div className='space-y-4'>
        <div>
          <DocumentNumberFieldV2
            ma_ct={MA_CHUNG_TU.BAN_HANG.BUT_TOAN_DIEU_CHINH_GIAM_CONG_NO}
            onQuyenChungTuChange={setQuyenChungTu}
            soChungTu={soChungTu}
            onSoChungTuChange={setSoChungTu}
            disabled={formMode === 'view'}
            classNameSearchField='w-full'
            formMode={formMode}
          />
        </div>

        <div className='flex items-center space-x-4'>
          <Label className='w-32 shrink-0'>Ngày chứng từ</Label>
          <div className='flex-1'>
            <FormFieldV2 name='ngay_ct' type='date' disabled={isViewMode} className='w-full' />
          </div>
        </div>

        <div className='flex items-center space-x-4'>
          <Label className='w-32 shrink-0'>Ngày lập chứng từ</Label>
          <div className='flex-1'>
            <FormFieldV2 name='ngay_lct' type='date' disabled={isViewMode} className='w-full' />
          </div>
        </div>

        <div className='flex items-center space-x-4'>
          <div className='flex-1'>
            <CurrencyInputV2 formMode={formMode} />
          </div>
        </div>

        <div className='flex items-center space-x-4'>
          <Label className='w-32 shrink-0'>Trạng thái</Label>
          <div className='flex-1'>
            <FormFieldV2
              name='status'
              type='select'
              disabled={isViewMode}
              options={[
                { value: '0', label: 'Chưa ghi sổ' },
                { value: '3', label: 'Chờ duyệt' },
                { value: '5', label: 'Đã ghi sổ' },
                { value: '6', label: 'Đang thực hiện' },
                { value: '7', label: 'Hoàn thành' },
                { value: '9', label: 'Hủy' }
              ]}
              className='w-full'
            />
          </div>
        </div>

        <div className='flex items-center space-x-4'>
          <div className='w-32 shrink-0'></div>
          <div className='flex-1'>
            <FormFieldV2 name='transfer_yn' type='checkbox' label='Dữ liệu được nhận' disabled={isViewMode} />
          </div>
        </div>
      </div>
    </div>
  );

  return (
    <div className='relative'>
      {formMode !== 'add' && initialData?.uuid && (
        <div className='absolute right-2 top-2 z-10'>
          <InfoDropdown uuid={initialData.uuid} ma_ct={initialData?.chung_tu} />
        </div>
      )}
      {InforTab}
    </div>
  );
}
